import { z } from 'zod'
import { ContentfulRichTextDocumentSchema } from './common'
import { ContentfulHeroSchema } from './hero'
import { ContentfulPageSectionSchema } from './pageSection'
import { ContentfulPageBannerSchema } from './pageBanner'
import {
  ContentfulAccordionItemSchema,
  ContentfulAccordionSectionSchema,
  ContentfulEducationalComponentSchema,
} from './components'

const ContentfulStaticPageComponentsSchema = z.union([
  ContentfulPageSectionSchema,
  ContentfulPageBannerSchema,
  ContentfulEducationalComponentSchema,
  ContentfulAccordionSectionSchema,
])

export type ContentfulStaticPageComponents = z.infer<typeof ContentfulStaticPageComponentsSchema>

export const ContentfulStaticPageContentSchema = z.object({
  name: z.string().optional(),
  identifier: z.string().optional(),
  hero: ContentfulHeroSchema.optional(),
  staticContent: ContentfulRichTextDocumentSchema.optional(),
  staticComponents: z
    .array(ContentfulStaticPageComponentsSchema.nullable())
    .transform((arr) => arr.filter((item): item is ContentfulStaticPageComponents => item !== null))
    .optional(),
  thumbnail: z.string().optional(),
  // accordion deprecated - to be removed once all content is migrated
  accordion: z
    .array(ContentfulAccordionItemSchema.nullable())
    .transform((arr) =>
      arr.filter((item): item is z.infer<typeof ContentfulAccordionItemSchema> => item !== null)
    )
    .optional(),
  contentType: z.literal('staticPage'),
})

export type ContentfulStaticPageContent = z.infer<typeof ContentfulStaticPageContentSchema>
